
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/[slug]",
      function () {
        return require("private-next-pages/preview/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/[slug]"])
      });
    }
  